// Wraps the localStorage calls in a try catch so that if it fails we don't
// raise any errors. Safari for iOS usually has issues with the localStorage
// API in private mode.

const dispatchLocalStorageEvent = (
    key: string | null,
    newValue: string | null,
) => {
    try {
        window.dispatchEvent(
            new CustomEvent("local-storage", { detail: { key, newValue } }),
        );
    } catch {
        try {
            const ev = document.createEvent("CustomEvent") as any;
            ev.initCustomEvent("local-storage", false, false, {
                key,
                newValue,
            });
            window.dispatchEvent(ev);
        } catch {
            // ignore if CustomEvent isn't supported
        }
    }
};

export const getItem = (key: string) => {
    try {
        return window.localStorage.getItem(key);
    } catch {
        return null;
    }
};
export const removeItem = (key: string) => {
    try {
        window.localStorage.removeItem(key);
        dispatchLocalStorageEvent(key, null);
    } catch {}
};
export const setItem = (key: string, value: string) => {
    try {
        window.localStorage.setItem(key, value);
        dispatchLocalStorageEvent(key, value);
    } catch {}
};
